import { Link, NavLink } from "react-router-dom";
import { useState } from "react";
import { Menu, X } from "lucide-react";
import { LOGO_URL } from "../lib/api";

const links = [
  { to: "/", label: "Inicio" },
  { to: "/servicios", label: "Servicios" },
  { to: "/soluciones", label: "Soluciones" },
  { to: "/casos", label: "Casos" },
  { to: "/utilidades", label: "Utilidades" },
  { to: "/cotizador", label: "Cotizador" },
  { to: "/contacto", label: "Contacto" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="main-navbar"
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-ink-800/80 border-b border-ink-500"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo-link" className="flex items-center shrink-0">
          <img
            src={LOGO_URL}
            alt="DoSoft"
            className="h-10 md:h-12 w-auto object-contain"
            style={{ filter: "brightness(0) invert(1)" }}
          />
        </Link>

        {/* Desktop nav */}
        <nav className="hidden lg:flex items-center gap-10">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.to.replace("/", "") || "home"}`}
              className={({ isActive }) =>
                `text-xs font-semibold uppercase tracking-widest hover-line transition-colors ${
                  isActive ? "text-brand" : "text-ash-300 hover:text-ash-100"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-4">
          <Link
            to="/cotizador"
            data-testid="nav-cta-quote"
            className="bg-brand text-ink-800 font-semibold hover:bg-brand-hover px-5 py-3 transition-colors uppercase tracking-wider text-xs"
          >
            Cotizar Proyecto
          </Link>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
          onClick={() => setOpen(!open)}
          className="lg:hidden p-2 text-ash-100"
        >
          {open ? <X size={24} strokeWidth={1.5} /> : <Menu size={24} strokeWidth={1.5} />}
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="lg:hidden bg-ink-800 border-t border-ink-500" data-testid="nav-mobile-menu">
          <nav className="flex flex-col px-6 py-6 gap-5">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-link-${l.to.replace("/", "") || "home"}`}
                className={({ isActive }) =>
                  `text-sm uppercase tracking-widest font-semibold ${
                    isActive ? "text-brand" : "text-ash-300"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/cotizador"
              onClick={() => setOpen(false)}
              data-testid="mobile-nav-cta-quote"
              className="bg-brand text-ink-800 font-semibold px-5 py-3 uppercase tracking-wider text-xs text-center"
            >
              Cotizar Proyecto
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}
